import React from 'react';

const MonthFilterSelect = ({ value, onChange, options }) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <select id="monthFilter" className="form-select" value={value} onChange={handleChange}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MonthFilterSelect;
